import logo from './logo.svg';
import './App.css';
import Header from 'components/Header';
import Hero from 'components/Hero';
import Home from 'pages/Home';

function App() {
  return (
    <div className="xl:pr-12 xl:pl-12 pt-0 xl:pt-16">

      <Home />
    </div>
  );
}

export default App;
